<template>
  <div class="oauth-complete">
    <form class="oauth-complete__card" @submit.prevent="submit">
      <div class="oauth-complete__head">
        <h1>Почти готово</h1>
        <p>Вход через Google/Яндекс прошёл. Укажите название магазина — пароль не нужен.</p>
      </div>

      <label class="oauth-complete__field">
        <span>Название магазина</span>
        <div class="oauth-complete__input">
          <i class="mdi mdi-storefront-outline"></i>
          <input
            v-model.trim="companyName"
            type="text"
            placeholder="Например: Дүкен №1"
            required
            autofocus
          >
        </div>
      </label>

      <button type="submit" class="oauth-complete__submit" :disabled="loading">
        <i v-if="loading" class="mdi mdi-loading mdi-spin"></i>
        {{ loading ? 'Создаём...' : 'Открыть кассу' }}
      </button>

      <button type="button" class="oauth-complete__back" @click="$router.push('/kassa-login')">
        Назад ко входу
      </button>
    </form>
  </div>
</template>

<script>
import { completeSocialRegistration, persistAuthSession } from '@/api/auth'
import { notify, notifyError } from '@/utils/notify'

export default {
  name: 'AuthComplete',
  data() {
    return {
      companyName: '',
      loading: false,
      ticket: '',
    }
  },
  mounted() {
    this.ticket = String((this.$route.query && this.$route.query.ticket) || '')
    if (!this.ticket) {
      notify('Сессия входа не найдена. Войдите снова', 'warning')
      this.$router.replace('/kassa-login')
    }
  },
  methods: {
    async submit() {
      if (!this.companyName) {
        notify('Укажите название магазина', 'warning')
        return
      }
      this.loading = true
      try {
        const data = await completeSocialRegistration({
          ticket: this.ticket,
          company_name: this.companyName,
        })
        persistAuthSession(data)
        notify('Магазин создан')
        this.$router.replace('/cash')
      } catch (error) {
        notifyError(error, 'Не удалось завершить регистрацию')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.oauth-complete {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #f6f9fc;
}

.oauth-complete__card {
  width: 100%;
  max-width: 420px;
  padding: 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #d9e2ec;
}

.oauth-complete__head h1 {
  margin: 0;
  font-size: 24px;
  color: #152033;
}

.oauth-complete__head p {
  margin: 8px 0 0;
  color: #6b7a90;
  font-size: 14px;
}

.oauth-complete__field {
  display: block;
  margin-top: 22px;
}

.oauth-complete__field > span {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 650;
  color: #3d4f63;
}

.oauth-complete__input {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 12px;
  border: 1px solid #d9e2ec;
  border-radius: 12px;
}

.oauth-complete__input i {
  color: #6b7a90;
}

.oauth-complete__input input {
  flex: 1;
  border: 0;
  outline: 0;
  min-height: 44px;
  font-size: 15px;
}

.oauth-complete__submit {
  width: 100%;
  margin-top: 18px;
  min-height: 46px;
  border: 0;
  border-radius: 12px;
  background: #0b4f8a;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

.oauth-complete__submit:disabled {
  opacity: 0.7;
  cursor: wait;
}

.oauth-complete__back {
  width: 100%;
  margin-top: 10px;
  min-height: 42px;
  border: 0;
  background: transparent;
  color: #6b7a90;
  cursor: pointer;
}
</style>
